<template>
  <Modal
    v-model="modalVisible"
    title="生成代码"
    @on-visible-change="change">
    <div style="padding: 20px 30px 20px 0;">
      <Form ref="form" :model="generate" :label-width="100" :rules="ruleArr">
        <FormItem label="代码类型">
          <RadioGroup v-model="generate.flag">
            <Radio label="web">前端</Radio>
            <Radio label="code">后端</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="生成方式">
          <RadioGroup v-model="generate.downWhere">
            <Radio label="browser">下载压缩包</Radio>
            <Radio label="explorer">生成到文件目录</Radio>
          </RadioGroup>
        </FormItem>
        <div :style="{display: generate.downWhere === 'browser'?'none':'block'}">
          <FormItem label="路径" v-if="generate.flag === 'web'" prop="webPath">
            <Input v-model="generate.webPath" style="width: 320px"></Input>
          </FormItem>
          <FormItem label="路径" v-if="generate.flag === 'code'" prop="codePath">
            <Input v-model="generate.codePath" style="width: 320px"></Input>
          </FormItem>
        </div>
      </Form>
    </div>
    <div slot="footer">
      <Button size="large" @click="cancel">返回</Button>
      <Button type="primary" size="large" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
  import Util from '@/libs/util.js';
  import Qs from 'qs'
  export default {
    name: 'generateForm',
    data () {
      return {
        modalVisible: false,
        generate: {
          id: null,
          flag: 'web',
          downWhere: 'browser',
          webPath: '',
          codePath: ''
        },
        ruleArr: {
          webPath: [
            {required: true,message:'请填写路径！', trigger: 'blur'},
          ],
          codePath: [
            {required: true,message:'请填写路径！', trigger: 'blur'},
          ],
        }
      };
    },
    methods: {
      ok () {
        let _this = this;
        if (this.generate.flag === 'web') {
          if(this.generate.downWhere === 'explorer') {
            this.$refs['form'].validate((valid) => {
              if (valid) {
                _this.genWeb();
              }
            });
          }else {
            _this.genWeb();
          }
        } else {
          if(this.generate.downWhere === 'explorer') {
            this.$refs['form'].validate((valid) => {
              if (valid) {
                _this.genCode();
              }
            });
          }else {
            _this.genCode();
          }
        }
      },
      genWeb () {
        let This = this;
        const [url, param,httpConfig] = [
          '/api/genWeb',
          Qs.stringify({
            formId: This.generate.id,
            path: This.generate.webPath,

          }),
          {
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ]
        This.$http.post(url, param,httpConfig).then(response => {
          This.$Notice.success({
          title: '操作成功'
        });
        This.modalVisible = false;
        if (response.data) {
          if (response.data.size > 0) {
            const content = response.data;
            const blob = new Blob([content]);//构造一个blob对象来处理数据
            const fileName = response.headers['content-disposition'].split("=")[1];
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob但是依然不支持download
            if ('download' in document.createElement('a')) { //支持a标签download的浏览器
              const link = document.createElement('a')//创建a标签
              link.download = fileName//a标签添加属性
              link.style.display = 'none'
              link.href = window.URL.createObjectURL(blob)
              document.body.appendChild(link)
              link.click()//执行下载
              window.URL.revokeObjectURL(link.href) //释放url
              document.body.removeChild(link)//释放标签
            } else { //其他浏览器
              navigator.msSaveBlob(blob, fileName)
            }

          }
        }
      }
      )
      .catch(function (error) {
          This.$Notice.error({
            title: '操作失败'
          });
          console.log(error);
        });
      },
      genCode () {
        let This = this;
        const [url, param,httpConfig] = [
          '/api/genCode',
          Qs.stringify({
            formId: This.generate.id,
            path: This.generate.codePath,

          }),
          {
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ]
        This.$http.post(url, param,httpConfig).then(function (response) {
          This.$Notice.success({
            title: '操作成功'
          });
          This.modalVisible = false;
          if (response.data) {
            if (response.data.size > 0) {
              const content = response.data;
              const blob = new Blob([content]);//构造一个blob对象来处理数据
              const fileName = response.headers['content-disposition'].split("=")[1];
              //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
              //IE10以上支持blob但是依然不支持download
              if ('download' in document.createElement('a')) { //支持a标签download的浏览器
                const link = document.createElement('a')//创建a标签
                link.download = fileName//a标签添加属性
                link.style.display = 'none'
                link.href = window.URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()//执行下载
                window.URL.revokeObjectURL(link.href) //释放url
                document.body.removeChild(link)//释放标签
              } else { //其他浏览器
                navigator.msSaveBlob(blob, fileName)
              }

            }
          }
        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败'
            });
            console.log(error);
          });
      },
      change (flag) {
        if (!flag) {
          this.generate = {
            id: null,
            flag: 'web',
            downWhere: 'browser',
            webPath: '',
            codePath: ''
          };
          this.$refs['form'].resetFields();
        }
      },
      cancel () {
        this.modalVisible = false;
      }
    }
  };
</script>

<style scoped>

</style>
